<template>
  <div>
    <div class="title-wrapper">
      <div class="title">员工端</div>
      <img class="backdrop" src="../../assets/images/login-bj.png">
      <div class="logo">
        <img :src="sign.head_img">
      </div>
    </div>
    <div class="input-title-wrapper">登录</div>
    <div class="input-wrapper">
      <input type="text" class="username" v-model="mobile" placeholder="请输入手机号码">
    </div>
    <div class="input-wrapper">
      <input type="text" class="password" v-model="mobile_code" placeholder="请输入验证码">
      <span class="sendcode" @click="sendCode()" v-if="showCode">发送验证码</span>
      <span class="sendcode" v-else>验证码 {{count}} s</span>
    </div>
    <div class="btns-wrapper">
      <a href="#">您第一次使用微信授权登录，需要验证手机号</a>
      <div class="input-wrapper">
        <input type="submit" value="登录" @click="getBindTel()" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Account',
  data () {
    return {
      mobile: '',
      mobile_code: '',
      count: '',
      showCode: true,
      sign: ''
    }
  },
  computed: {
    ...mapState(['appid', 'openid', 'usertel', 'headPortrait'])
  },
  created () {
    this.wechatBasic()
  },
  methods: {
    ...mapMutations(['changeArgs']),
    wechatBasic () {
      this.axios.post('/wechat/index/wechatBasic', {
        appid: this.appid
      }).then((res) => {
        if (res.data.status === 1) {
          this.sign = res.data.data
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    sendCode () {
      if (this.mobile === '') {
        this.$toast({
          message: '请输入手机号',
          duration: 3000
        })
        return false
      }
      this.axios.post('/wechat/index/bindTel/', {
        openid: this.openid,
        authorizer_appid: this.appid,
        tel: this.mobile,
        head_portrait: this.headPortrait
      }).then((res) => {
        if (res.data.status === 1) {
          this.axios.post('/wechat/SendSms/index/mobile/' + this.mobile)
            .then((res) => {
              if (res.data.status === 1) {
                this.code = res.data.data

                // 验证码倒计时
                const TIME_COUNT = 60
                if (!this.timer) {
                  this.count = TIME_COUNT
                  this.showCode = false
                  this.timer = setInterval(() => {
                    console.log(this.count)
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--
                      this.showCode = false
                    } else {
                      this.showCode = true
                      clearInterval(this.timer)
                      this.timer = null
                    }
                  }, 1000)
                }
                setTimeout(() => {
                  console.log(this.code + '已失效')
                }, 54000)
              }
            }).catch(() => {
              this.$toast({
                message: '网络错误',
                duration: 5000
              })
            })
        } else {
          this.$messagebox({
            message: '没有可以访问的小区',
            closeOnClickModal: false,
            showCancelButton: false,
            confirmButtonText: '好的'
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    getBindTel () {
      if (this.mobile === '') {
        this.$toast({
          message: '请输入手机号',
          duration: 3000
        })
        return false
      }
      if (this.mobile_code !== this.code) {
        this.$toast({
          message: '验证码不正确',
          duration: 3000
        })
        return false
      }
      this.axios.post('/wechat/index/bindTel/', {
        openid: this.openid,
        authorizer_appid: this.appid,
        tel: this.mobile,
        head_portrait: this.headPortrait
      }).then((res) => {
        if (res.data.status === 1) {
          this.changeArgs({usertel: this.mobile})
          this.$router.push({name: 'Index'})
        } else {
          this.$messagebox({
            message: '没有可以访问的小区',
            closeOnClickModal: false,
            showCancelButton: false,
            confirmButtonText: '好的'
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.title-wrapper .title {
  font-size: 20px;
  color: #000000;
  margin-top: 15px;
  text-align: center;
}
.title-wrapper .backdrop {
  width: 100%;
}
.title-wrapper .logo {
  width: 100px;
  height: 100px;
  background-color: #ffffff;
  border-radius: 24px;
  margin: -65px auto 0 auto;
  text-align: center;
  position: relative;
}
.title-wrapper .logo img {
  width: 80px;
  height: 80px;
  margin-top: 10px;
}
.input-title-wrapper {
  font-size: 22px;
  letter-spacing: 4px;
  margin: 15px 0;
  color: #000000;
  text-align: center;
}
.input-wrapper {
  margin: 10px 38px;
  display: flex;
  position: relative;
}
.input-wrapper input {
  flex: 1;
  height: 35px;
  background-color: #f4f4f4;
  border-radius: 20px;
  border: none;
  font-size: 13px;
  outline: none;
}
.input-wrapper .sendcode {
  position: absolute;
  top: 8px;
  right: 15px;
  font-size: 13px;
  color: #000000;
}
.input-wrapper .username,.password {
  background-position: 14px center;
  background-size: 16px 16px;
  background-repeat: no-repeat;
  padding: 0 5px 0 38px;
}
.input-wrapper .username {
  background-image: url(../../assets/images/login-username.png);
}
.input-wrapper .password {
  background-image: url(../../assets/images/login-password.png);
}
.btns-wrapper {
  margin-top: 30px;
  text-align: center;
}
.btns-wrapper a {
  font-size: 11px;
  letter-spacing: 1px;
  color: #929292;
  text-decoration: none;
}
.btns-wrapper .input-wrapper input {
  background-color: #ff9a0a;
  color: #ffffff;
  letter-spacing: 2px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Account.vue